import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import UserSelect from "./UserSelect";

const LocationTabs = ({
  onLocationChange,
  onBatchChange,
  onUserChange,
  isFromBatchManager,
}) => {
  const [activeTab, setActiveTab] = useState("Madison");
  const [location, setLocation] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    // Set the default location when switching tabs
    switch (tab) {
      case "Madison":
        setLocation("Madison 1");
        onLocationChange("Madison 1");
        break;
      case "Carmel":
        setLocation("Carmel 1");
        onLocationChange("Carmel 1");
        break;
      case "Lafayette":
        setLocation("Lafayette 1");
        onLocationChange("Lafayette 1");
        break;
      default:
        setLocation("");
    }
  };

  const handleLocationChange = (newLocation) => {
    setLocation(newLocation);
    onLocationChange(newLocation);
  };

  const handleBatchChange = (batch) => {
    setSelectedBatch(batch);
    onBatchChange(mapToBackendBatch(batch));
  };

  const handleUserChange = (newUser) => {
    onUserChange(newUser);
  };

  const commonLocationOptions = {
    Madison: ["Madison 1", "Madison 2", "Madison 3"],
    Carmel: ["Carmel 1", "Carmel 2", "Carmel 3", "Carmel 4"],
    Lafayette: ["Lafayette 1"],
  };

  const mapToBackendBatch = (frontendBatch) => {
    const batchMappings = {
      "HPC (DW)": "HPCDW",
      "HPC (Pool)": "HPC",
      "TC (DW)": "TCDW",
      "TC (Pool)": "TCPOOL",
      "E.coli": "Ecoli",
    };
    return batchMappings[frontendBatch] || frontendBatch;
  };

  const batches = ["HPC (DW)", "HPC (Pool)", "TC (DW)", "TC (Pool)", "E.coli"];

  return (
    <div>
      <div className="tabs is-boxed">
        <ul>
          {["Madison", "Carmel", "Lafayette"].map((tab) => (
            <li key={tab} className={activeTab === tab ? "is-active" : ""}>
              <a onClick={() => handleTabClick(tab)}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faGlobe} />
                </span>
                <span>{tab}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="content">
        <div className="container">
          <div className="columns">
            {!isFromBatchManager && (
              <div className="column">
                <label htmlFor="" className="label">
                  Select Location
                </label>
                <select
                  className="input"
                  value={location}
                  onChange={(e) => handleLocationChange(e.target.value)}
                >
                  {commonLocationOptions[activeTab].map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {!isFromBatchManager && (
              <div className="column" style={{ marginTop: "5px" }}>
                <UserSelect userChanged={handleUserChange} Filter="ANALYSTS" />
              </div>
            )}

            {isFromBatchManager && (
              <div className="column">
                <div>
                  <label htmlFor="" className="label">
                    Select Batch
                  </label>
                  <select
                    className="input"
                    value={selectedBatch}
                    onChange={(e) => handleBatchChange(e.target.value)}
                  >
                    {batches.map((batch) => (
                      <option key={batch} value={batch}>
                        {batch}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="column"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationTabs;
